import {
  TextareaAutosize as MUITextareaAutosize,
  TextareaAutosizeProps,
} from "@mui/material";
import clsx from "clsx";

import { useStore } from "@/app/model/RootStoreContext";

import styles from "./styles.module.css";

interface IProps extends TextareaAutosizeProps {}

const TextareaAutosize = ({ className, ...restProps }: IProps) => {
  const { uiStore } = useStore();

  return (
    <MUITextareaAutosize
      className={clsx(className, styles.textarea)}
      autoFocus={!uiStore.isMobile}
      {...restProps}
    />
  );
};

export default TextareaAutosize;
